import http from "./Instance";
import {Currency} from "../models/Currency";

const urlPrefix = 'currencies';

export const getCurrencies = () => {
    return http.get<Currency[]>(`${urlPrefix}/`);
}